import { gql } from '@apollo/client'

export const REVERT_CLASSIFICATION_BATCH = gql`
  mutation RevertClassificationBatch($input: SubmitClassificationBatchInput!) {
    revertClassificationBatch(input: $input) {
      __typename
      ... on RevertClassificationBatchResult {
        ok
      }
    }
  }
`
